import { call, put, takeLatest } from "redux-saga/effects";
import {
  wholesalerProductAddSuccess,
  wholesalerProductAddFailure,
  wholesalerProductEditSuccess,
  wholesalerProductEditFailure,
  wholesalerProductDeleteSuccess,
  wholesalerProductDeleteFailure,
  wholesalerProductViewSuccess,
  wholesalerProductViewFailure,
  wholesalerProductViewAllSuccess,
  wholesalerProductViewAllFailure,
  wholesalerProductSearchViewAllSuccess,
  wholesalerProductSearchViewAllFailure,
  wholesalerProductViewByWholesalerIdSuccess,
  wholesalerProductByWholesalerIdViewFailure,
  wholesalerProductSearchViewByWholesalerIdSuccess,
  wholesalerProductSearchByWholesalerIdViewFailure,
} from "./WholesalerProductAction";

import {
  WHOLESALER_PRODUCT_ADD_REQUEST,
  WHOLESALER_PRODUCT_EDIT_REQUEST,
  WHOLESALER_PRODUCT_DELETE_REQUEST,
  WHOLESALER_PRODUCT_VIEW_REQUEST,
  WHOLESALER_PRODUCT_VIEW_ALL_REQUEST,
  WHOLESALER_PRODUCT_SEARCH_REQUEST,
  WHOLESALER_PRODUCT_VIEW_WHOLESALERID_REQUEST,
  WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_REQUEST,
} from "./WholesalerProductTypes";

import {
  AddWholesalerProductEffect,
  EditWholesalerProductEffect,
  DeleteWholesalerProductEffect,
  ViewWholesalerProductEffect,
  ViewAllWholesalerProductsEffect,
  ViewAllSearchWholesalerProductsEffect,
  ViewAllWholesalerProductsByWholesalerIdEffect,
  ViewAllSearchWholesalerProductsByWholesalerIdEffect,
} from "./WholesalerProductEffect";

// Add Wholesaler Product
function* addWholesalerProductSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      AddWholesalerProductEffect,
      action.payload,
      config
    );
    yield put(wholesalerProductAddSuccess(response.data));
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message = error.response?.data?.message || "Failed to add product";
    yield put(
      wholesalerProductAddFailure({
        errormessage: message,
        errorFields,
      })
    );
  }
}

// Edit Wholesaler Product
function* editWholesalerProductSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const { wholesalerProductId, updates } = action.payload;
    const response = yield call(
      EditWholesalerProductEffect,
      wholesalerProductId,
      updates,
      config
    );
    yield put(wholesalerProductEditSuccess(response.data));
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message = error.response?.data?.message || "Failed to update product";
    yield put(
      wholesalerProductEditFailure({
        errormessage: message,
        errorFields,
      })
    );
  }
}

// View Wholesaler Product
function* viewWholesalerProductSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      ViewWholesalerProductEffect,
      action.payload,
      config
    );
    yield put(wholesalerProductViewSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch product details";
    yield put(wholesalerProductViewFailure({ errormessage: errorMessage }));
  }
}

// View  Wholesaler Products By Wholesaler Id
function* viewAllWholesalerProductsByWholesalerIdSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const { wholesalerProductId, pageNo, search_key } = action.payload;

    const response = yield call(
      ViewAllWholesalerProductsByWholesalerIdEffect,
      wholesalerProductId,
      pageNo,
      search_key,
      config
    );

    yield put(wholesalerProductViewByWholesalerIdSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(
      wholesalerProductByWholesalerIdViewFailure({ errormessage: errorMessage })
    );
  }
}

// View Search Wholesaler Products By Wholesaler Id
function* viewSearchWholesalerProductsByWholesalerIdSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};

    const { wholesalerProductId } = action.payload;

    const response = yield call(
      ViewAllSearchWholesalerProductsByWholesalerIdEffect,
      wholesalerProductId,
      config
    );
    yield put(wholesalerProductSearchViewByWholesalerIdSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch brands";
    yield put(
      wholesalerProductSearchByWholesalerIdViewFailure({
        errormessage: errorMessage,
      })
    );
  }
}

// View All Wholesaler Products
function* viewAllWholesalerProductsSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      ViewAllWholesalerProductsEffect,
      action.payload,
      config
    );

    yield put(wholesalerProductViewAllSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch products";
    yield put(wholesalerProductViewAllFailure({ errormessage: errorMessage }));
  }
}

// View All Search Wholesaler Products
function* viewAllSearchWholesalerProductsSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      ViewAllSearchWholesalerProductsEffect,
      action.payload,
      config
    );
    yield put(wholesalerProductSearchViewAllSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch brands";
    yield put(
      wholesalerProductSearchViewAllFailure({ errormessage: errorMessage })
    );
  }
}

// Delete Wholesaler Product
function* deleteWholesalerProductSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");

    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      DeleteWholesalerProductEffect,
      action.payload,
      config
    );
    yield put(wholesalerProductDeleteSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to delete product";
    yield put(wholesalerProductDeleteFailure({ errormessage: errorMessage }));
  }
}

export function* WholesalerProductSaga() {
  yield takeLatest(WHOLESALER_PRODUCT_ADD_REQUEST, addWholesalerProductSaga);
  yield takeLatest(WHOLESALER_PRODUCT_EDIT_REQUEST, editWholesalerProductSaga);
  yield takeLatest(
    WHOLESALER_PRODUCT_DELETE_REQUEST,
    deleteWholesalerProductSaga
  );
  yield takeLatest(WHOLESALER_PRODUCT_VIEW_REQUEST, viewWholesalerProductSaga);
  yield takeLatest(
    WHOLESALER_PRODUCT_VIEW_WHOLESALERID_REQUEST,
    viewAllWholesalerProductsByWholesalerIdSaga
  );
  yield takeLatest(
    WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_REQUEST,
    viewSearchWholesalerProductsByWholesalerIdSaga
  );
  yield takeLatest(
    WHOLESALER_PRODUCT_VIEW_ALL_REQUEST,
    viewAllWholesalerProductsSaga
  );
  yield takeLatest(
    WHOLESALER_PRODUCT_SEARCH_REQUEST,
    viewAllSearchWholesalerProductsSaga
  );
}
